import React from "react";
import { NavLink } from "react-router-dom";

import { Row, Col } from "reactstrap";
import PhoneIcon from "../../images/call_icon.png";

import { notify } from "react-notify-toast";
import notification from "../../images/notifications_white.svg";
import loader from "../../images/loader.gif";
import GetTime from "../GetTime.js";
// import OrderInTransit from "./ViewTripList/OrderInTransit";
import OrderInTransit from "../Intransit/ViewTripList/OrderInTransit";

const ViewCompleteDeliver = (props) => {
  console.log("ghg", props.orderdetail);
  const tripDetails =
    props.orderdetail &&
    props.orderdetail.data &&
    props.orderdetail.data.trip_detail;
  const orderData =
    props.orderdetail &&
    props.orderdetail.data &&
    props.orderdetail.data.orders;
  // const {
  //   job_order_id,
  //   order_id,
  //   grand_total,
  //   payment_mode,
  //   customer_name,
  //   total_item_count,
  //   total_qty_ordered,
  //   customer_address,
  //   delivery_slot,
  //   telephone,
  // } = orderData;
  const getAddressFrom = (order) => {
    const addressString = [
      "flat_villa_no",
      "building",
      "street",
      "city",
      "postcode",
    ]
      .map((key) => {
        const lables = {
          street: "Street",
          city: "City",
          flat_villa_no: "Flat",
          building: "Building",
          postcode: "Pincode",
        };
        return orderData[key] && lables[key] + ":" + orderData[key];
      })
      .filter((n) => n)
      .join(", ");

    return addressString;
  };
  if (props.orderdetail && props.orderdetail.status == "success") {
    const data = props.orderdetail.data;
    // return (
    return (
      <div>
        <div className="inTransitHeader">
          <NavLink to="/completed">
            <i className="text-white float-left pt-1 pr-3 icon-prevarrow back-btn-arrow"></i>
          </NavLink>
          <span className="inTransitHeaderTitle">
            <span>JID:</span> {data.job.job_id}
          </span>
          <img
            className="float-right pt-1"
            // src={notification}
            // alt="notification"
          />
        </div>
        <div>
          {/*complete order detail header*/}
          {/* <div className="job_id">
            <div className="container">
              <span>Trip ID:</span> {data.job.job_id}
            </div>
          </div> */}
          <div className="trip_detail_container">
            <div className="container">
              <Row className="trip_details">
                <Col className="first trips_inner_details">
                  Orders: <p>{data.job.order_count}</p>
                </Col>
                <Col className="trips_inner_details">
                  Completed: <p>{data.job.completed_orders}</p>
                </Col>
                <Col className="trips_inner_details">
                  Assigned:{" "}
                  <p className="remove-padding">
                    <GetTime time={data.job.assigned_at} />
                  </p>
                </Col>
                <Col className="last trips_inner_details">
                  Finish by:{" "}
                  <p className="remove-padding">
                    <GetTime time={data.job.delivered_by} />
                  </p>
                </Col>
              </Row>
            </div>
          </div>
          {/*Trip detail*/}
          {data.orders &&
            data.orders.map((obj, k) => (
              <OrderInTransit
                key={k}
                trip_id={data.job.job_id}
                orderData={obj}
                index={k + 1}
                isFromAcceptModal={true}
              />
            ))}{" "}
          {/* <TripDetail tripDetailView={data.trip_detail} /> */}
          <div className="tripTitle">TRIP SUMMARY</div>
          <div className="tripDetails">
            Orders: {data.orders ? data.orders.length : 0}
          </div>
          <div className="tripDetails">
            Amount Due:{" "}
            {data.job.amount_to_be_collected > 0
              ? data.job.amount_to_be_collected
              : 0}
          </div>
          <div className="tripDetails">
          {data.job.amount_collected_card !== 0 ?
            (<div>Amount collected by Card 1: {data.job.amount_collected_card}</div>):null }

            {data.job.amount_collected_card_2 !== 0 ?
            (<div>Amount collected by Card 2: {data.job.amount_collected_card_2}</div>):null }


            {data.job.amount_collected_card_3 !== 0 ?
            (<div>Amount collected by Card 3: {data.job.amount_collected_card_3}</div>):null }


             {data.job.amount_collected_cash !== 0 ?
            (<div>Amount collected by Cash: {data.job.amount_collected_cash}</div>):null }
             {data.job.amount_collected_benefit_pay !== 0 ?
            (<div>Amount collected by Benefit Pay: {data.job.amount_collected_benefit_pay}</div>):null }
            {data.job.amount_collected_bmmi_ala !== 0 ?
            (<div>Amount collected by BMMI ALA: {data.job.amount_collected_bmmi_ala}</div>):null }
            {data.job.amount_collected_on_credit !== 0 ?
            (<div>Amount collected by On Credit: {data.job.amount_collected_on_credit}</div>):null }
                {data.job.amount_collected_short_paid !== 0 ?
            (<div>Amount collected by Short Paid: {data.job.amount_collected_short_paid}</div>):null }
            {data.job.amount_collected_store_credit !== 0 ?
            (<div>Amount collected by Store Credit: {data.job.amount_collected_store_credit}</div>):null }
          </div>
      
          {/* {this.props &&
          this.props.delayorderData &&
          this.props.delayorderData.length ? (
            <DelayReport delayReport={this.props.delayorderData} />
          ) : (
            ""
          )} */}
        </div>
      </div>
    );
    //   <div>
    //     {orderData &&
    //       orderData.map((order) => (
    //         <div className="delivery_order_container pt-2">
    //           <Row className="order_datas">
    //             <Col xs="2" className="order_index order_data_details">
    //               <span>{order.job_order_id}</span>
    //             </Col>
    //             <Col xs="3" className="order_data_details">
    //               Order ID: <p>{order.order_id}</p>
    //             </Col>
    //             <Col xs="3" className="order_data_details">
    //               Amount <p>{order.grand_total}</p>
    //             </Col>
    //             <Col xs="4" className="order_data_details">
    //               Payment Mode <p>{order.payment_method}</p>
    //             </Col>
    //           </Row>
    //           <table className="order_data_table w-100 p-3 d-inline-block">
    //             <tbody className="w-100 d-inline-block">
    //               <tr>
    //                 <td className="order_data_label pb-2">Customer Name:</td>
    //                 <td className="pb-2">{order.customer_name}</td>
    //               </tr>
    //               <tr>
    //                 <td className="order_data_label pb-2">Quantity:</td>
    //                 <td className="pb-2">
    //                   {parseInt(order.total_items)}{" "}
    //                   {parseInt(order.total_items) > 1 ? "Items" : "Item"}

    //                 </td>
    //               </tr>
    //               <tr>
    //                 <td className="order_data_label pb-2">Address:</td>
    //                 <td className="pb-2">
    //                   {getAddressFrom(order)}
    //                   <br />
    //                   {order.location}
    //                 </td>

    //               </tr>
    //               <tr>
    //                 <td className="order_data_label pb-2">Delivery Slot:</td>
    //                 <td className="pb-2">{order.slot_time}</td>
    //               </tr>
    //               <tr>
    //                 <td className="order_data_label pb-2">Phone:</td>
    //                 <td className="pb-2">
    //                   <a href={`tel:${order.telephone}`}>
    //                     <img src={PhoneIcon} alt="Phone" />
    //                   </a>
    //                 </td>
    //               </tr>
    //             </tbody>
    //           </table>
    //         </div>
    //       ))}
    //     <div className="order_data_table w-100 p-3 d-inline-block">
    //       <h5>Trip details</h5>
    //       <table className="order_data_table w-100 p-3 d-inline-block">
    //         <tbody className="w-100 d-inline-block">
    //           <tr>
    //             <td className="order_data_label pb-2">Order Qty:</td>
    //             <td className="pb-2">{tripDetails.total_orders}</td>
    //           </tr>
    //           <tr>
    //             <td className="order_data_label pb-2">Assigned Date:</td>
    //             <td className="pb-2">
    //               {tripDetails.assigned_date}
    //               {"  "}
    //               {tripDetails.assigned_time}
    //             </td>
    //           </tr>

    //           <tr>
    //             <td className="order_data_label pb-2">Total Bags:</td>
    //             <td className="pb-2">{tripDetails.total_bags}</td>
    //           </tr>
    //           <tr>
    //             <td className="order_data_label pb-2">Delay:</td>
    //             <td className="pb-2">{tripDetails.running_delay}</td>
    //           </tr>
    //         </tbody>
    //       </table>
    //     </div>
    //   </div>
    // );
  } else {
    return <div>No data</div>;
  }
};
export default ViewCompleteDeliver;



// WEBPACK FOOTER //
// ./src/components/Completed/viewCompleteDeliver.js